import { toSafeString } from './formatters';

export enum AutoTestIdPrefix {
  BUTTON = 'button',
  CARD = 'card',
  CHIP = 'chip',
  TAB = 'tab',
  DIVIDER = 'divider',
  DOCUMENT = 'document',
  DROPDOWN = 'dropdown',
  INPUT = 'input',
  LIST = 'list',
  SPAN = 'span',
  ACCORDION = 'accordion',
  SEARCH_FIELD = 'searchField',
}

export type GenerateAutoTestIdFn = (prefix: AutoTestIdPrefix | string, label: string | undefined) => string | undefined;

export const createGenerateAutoTestId = (isTestAutomationEnabled : boolean): GenerateAutoTestIdFn => {
  return (prefix: AutoTestIdPrefix | string, label: string | undefined): string | undefined => {
    if (!isTestAutomationEnabled  || !label) return undefined;

    const safeKey = toSafeString(label);
    return `${prefix}-${safeKey.toLowerCase().replace(/[\s/()._]+/g, '-')}`;
  };
};

export const getGenerateAutoTestId = (isTestAutomationEnabled : boolean): GenerateAutoTestIdFn => {
  return createGenerateAutoTestId(isTestAutomationEnabled);
};
